<section class="p-2 p-sm-3 p-md-4 animated fadeInLeft" fxLayout="column" fxLayoutAlign="center center"
    fxLayoutGap="16px">
    <img width="250" src="assets/images/billpocket_horizontal_white.svg" alt="Billpocket Logo">
    <mat-card class="mat-elevation-z3">
        <mat-card-content class="text-center" fxLayout="column" fxLayoutGap="16px">
            <h1 class="mb-3">Registrarse</h1>
            <form #signInForm="ngForm" fxLayout="column">
                <mat-form-field appearance="outline">
                    <mat-label>Correo Electrónico</mat-label>
                    <mat-icon class="material-icons-outlined" matPrefix>email</mat-icon>
                    <input type="email" matInput name="emailInp" #emailInp="ngModel" [(ngModel)]="user.email"
                        [pattern]="regEx.email" autocomplete="none" required>
                    <mat-error *ngIf="emailInp.errors?.required">
                        Por favor llena tu correo
                    </mat-error>
                    <mat-error *ngIf="emailInp.errors?.pattern">
                        Tu correo debe verse como ejemplo@correo.com
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Contraseña</mat-label>
                    <mat-icon class="material-icons-outlined" matPrefix>lock</mat-icon>
                    <input type="password" matInput appShowPassword placeholder="Crear contraseña" name="passwordInp"
                        #passwordInp="ngModel" [(ngModel)]="user.password" minlength="6" autocomplete="none" required>
                    <mat-error *ngIf="passwordInp.errors?.required">
                        Por favor llena tu contraseña
                    </mat-error>
                    <mat-error *ngIf="passwordInp.errors?.minlength">
                        Tu contraseña debe contener al menos 6 caracteres
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Teléfono</mat-label>
                    <mat-icon class="material-icons-outlined" matPrefix>phone</mat-icon>
                    <input matInput name="phoneInp" #phoneInp="ngModel" placeholder="10 dígitos"
                        [mask]="maskPhoneSeparator(user.phone)" [(ngModel)]="user.phone" minlength="10"
                        autocomplete="none" required (change)="repeatPhone=false">
                    <mat-error *ngIf="phoneInp.errors?.required">
                        Por favor llena tu número celular
                    </mat-error>
                    <mat-error *ngIf="phoneInp.errors?.minlength">
                        Tu número celular debe contener 10 dígitos
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Código de invitación</mat-label>
                    <input matInput name="referralCodeInp" #referralCode="ngModel" [(ngModel)]="user.referralCode"
                        autocomplete="none" minlength="3">
                    <mat-hint>Opcional</mat-hint>
                    <mat-error *ngIf="referralCode.errors?.minlength">
                        El código de invitación debe contener al menos 3 caracteres
                    </mat-error>
                </mat-form-field>

                <div class="mt-3" fxLayout="column" fxLayoutGap="16px">
                    <p>
                        ¿Ya tienes cuenta?
                        <a [href]="loginUrl">Iniciar sesión</a>
                    </p>
                    <button type="submit" mat-flat-button color="primary" [disabled]="loading" (click)="onSubmit()">
                        Crear tu cuenta
                    </button>
                </div>
            </form>
        </mat-card-content>
        <p class="rights">
            Al registrarte aceptas que has leído los
            <a href="http://ayuda.billpocket.com/support/solutions/articles/156346-t-rminos-y-condiciones-del-servicio"
                target="_blank" rel="noopener noreferrer">
                Términos y condiciones del servicio
            </a> y
            <a href="http://billpocket.com/privacidad" target="_blank" rel="noopener noreferrer">
                Aviso de privacidad.
            </a>
        </p>
    </mat-card>
</section>
